import { useAuth } from 'contexts/auth'
import api from 'services/api'

const useAxiosInterceptor = () => {
  const { signOut } = useAuth()

  api.interceptors.response.use(
    (response) => response,
    (error) => {
      if (error.response && error.response.status === 400) {
        if (error.response.data.data.message == 'Invalid token!') {
          signOut()
        }
      }

      if (error.response && error.response.status === 500) {
        if (error.response.data.data.message == 'invalid signature') {
          signOut()
        }
      }

      if (error.response && error.response.status === 500) {
        if (error.response.data.data.message == 'jwt expired') {
          signOut()
        }
      }

      if (error.response && error.response.status === 500) {
        if (error.response.data.data.message == 'invalid token') {
          signOut()
        }
      }

      if (error.response && error.response.status === 500) {
        if (error.response.data.data.message == 'jwt malformed') {
          signOut()
        }
      }

      if (error.response && error.response.status === 500) {
        if (error.response.data.data.message == 'jwt signature is required') {
          signOut()
        }
      }

      if (error.response && error.response.status === 500) {
        if (error.response.data.data.message == 'invalid signature') {
          signOut()
        }
      }

      return Promise.reject(error)
    }
  )
}

export default useAxiosInterceptor
